import React, { useCallback, useRef, useState } from 'react';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';

import { Popover, Tooltip } from 'antd';
import Chip from 'components/common/Chip/Chip';

import OrganisationSelector from './OrganisationSelector';

// Split out of FarmTreeViewNodes.tsx: that file is otherwise all plain
// builder functions (createFarmNode, buildFarmTreeData, ...), and mixing a
// component export in with those defeats React Fast Refresh's ability to
// hot-swap the module cleanly, forcing a full remount (or worse, a stuck
// dev-server state) on every edit to either.
const ICON_CLASS = 'mr-1.5 flex-shrink-0 text-gray-muted';
const ICON_SIZE = 14;

const OrgNodeTitle: React.FC<{ orgName: string }> = ({ orgName }) => {
  const [open, setOpen] = useState(false);
  const [popoverWidth, setPopoverWidth] = useState(256);
  const containerRef = useRef<HTMLSpanElement>(null);

  const handleOpenChange = useCallback((newOpen: boolean) => {
    if (newOpen && containerRef.current) {
      const tree = containerRef.current.closest(
        '.custom-tree'
      ) as HTMLElement | null;
      if (tree) {
        setPopoverWidth(tree.clientWidth);
      }
    }
    setOpen(newOpen);
  }, []);

  return (
    <span
      ref={containerRef}
      className="group flex min-w-0 flex-1 items-center"
    >
      <HiOutlineBuildingOffice2 className={ICON_CLASS} size={ICON_SIZE} />
      {/* No underline and no click handler here — the row itself is now the
          clickable/selectable area (antd's default tree-row behaviour),
          rather than only this label. */}
      <span className="truncate">{orgName}</span>
      <Popover
        open={open}
        onOpenChange={handleOpenChange}
        trigger="click"
        placement="bottomLeft"
        align={{ offset: [-28, -32] }}
        arrow={false}
        content={
          <div style={{ width: popoverWidth }}>
            <OrganisationSelector onSelect={() => setOpen(false)} />
          </div>
        }
      >
        <Tooltip title="Change Organisation" placement="right" mouseEnterDelay={0.5}>
          <button
            type="button"
            aria-label="Change organisation"
            className="ml-auto flex-shrink-0 focus:outline-none"
            onClick={(e) => e.stopPropagation()}
          >
            <Chip id="change-org" label="Change" />
          </button>
        </Tooltip>
      </Popover>
    </span>
  );
};

export default OrgNodeTitle;
